import React, { useState } from 'react'

import * as styles from './styles.module.scss'

import { useTranslation } from 'gatsby-plugin-react-i18next'
import { useTransition, animated } from 'react-spring'
import InView from 'react-intersection-observer'

interface Item {
	title: string
	text: string
	href?: string
	image?: string
	video?: string
	border?: boolean
}

const _items: Item[] = [
	{
		title: 'services.blog.title',
		href: 'https://www.notino.cz/beautyblog/',
		text: 'services.blog.text',
		image: '/2021/images/services/notino-blog.jpg'
	},
	{
		title: 'services.modiface.title',
		text: 'services.modiface.text',
		video: '/2021/images/services/modiface.mp4?v=2',
		border: true
	},
	{
		title: 'services.airparfum.title',
		text: 'services.airparfum.text',
		href: 'https://airparfum.com/',
		image: '/2021/images/services/airparfum.jpg'
	},
	{
		title: 'services.shadefinder.title',
		text: 'services.shadefinder.text',
		video: '/2021/images/services/shadefinder.mp4'
	},
	{
		title: 'services.hairDiagnostics.title',
		text: 'services.hairDiagnostics.text',
		image: '/2021/images/services/vlasova-diagnostika.jpeg'
	},
	{
		title: 'services.fragranceFinder.title',
		text: 'services.fragranceFinder.text',
		image: '/2021/images/services/fragrance-finder.jpg'
	},
	{
		title: 'services.discovery.title',
		text: 'services.discovery.text',
		image: '/2021/images/services/discovery-boxy.jpg?v=1'
	},
	{
		title: 'services.tryItFirst.title',
		text: 'services.tryItFirst.text',
		image: '/2021/images/services/try-it-first.jpg'
	},
	{
		title: 'services.mobile.title',
		text: 'services.mobile.text',
		href: 'https://www.notino.cz/aplikace/',
		image: '/2021/images/services/mobile.jpg?v=1'
	}
]

const Services: React.FC = () => {
	const { t } = useTranslation()

	const [items, setItems] = useState<Item[]>([])

	const transitions = useTransition(items, {
		from: { opacity: 0, transform: 'translateY(-40px)' },
		enter: { opacity: 1, transform: 'translateY(0)' },
		delay: 1000,
		trail: 400
	})

	return (
		<section className="position-relative">
			<div className="container">
				<h2 className="text-center mt-7 mb-6">{t('services.title')}</h2>
				<InView onChange={(inView) => inView && setItems(_items)}>
					<div className="row gx-4">
						{transitions((style, item) => (
							<animated.div className="col-lg-4 text-center mb-5" style={style}>
								{item.video ? (
									<div
										className={`${styles.videoContainer} ${
											item.border ? styles.imageBorder : undefined
										}`}
									>
										<video autoPlay className={styles.video} loop muted>
											<source src={item.video} type="video/mp4" />
										</video>
									</div>
								) : (
									<a
										href={item.href}
										target="_blank"
										className={item.href ? styles.imageLink : undefined}
									>
										<img
											src={item.image}
											alt={t(item.title)}
											className={`${styles.image} ${
												item.border ? styles.imageBorder : undefined
											}`}
										/>
									</a>
								)}
								<h4 className="text-primary font-weight-bold mt-4">
									{item.href ? (
										<a
											href={item.href}
											className={styles.externalLink}
											target="_blank"
										>
											{t(item.title)}
										</a>
									) : (
										<span className="text-primary">{t(item.title)}</span>
									)}
								</h4>
								<p className="h5 mt-3">{t(item.text)}</p>
							</animated.div>
						))}
					</div>
				</InView>
			</div>
		</section>
	)
}

export default Services
